
import Vue from 'vue';

import { faMagnifyingGlass } from '@delfi.lt/fa-kit/icons/modules/classic/light';
import { faAngleRight } from '@delfi.lt/fa-kit/icons/modules/classic/light';

interface Data {
  searchValue: string | null;
}

interface Methods {
  handleSearch: () => void;
}

interface Props {
  filter: string;
}

export default Vue.extend<Data, Methods, unknown, Props>({
  data() {
    return {
      searchValue: null,
      faMagnifyingGlass,
      faAngleRight,
    };
  },
  methods: {
    handleSearch() {
      this.$emit('search-tag', this.searchValue);
    },
  },
});
